(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-reservation"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'flosh_reserve';
    var memory = null; // stands in when the browser blocks localStorage: the deadline then lasts one page view
    var timer = null;

    function load() {
      var stored = null;
      try { stored = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
      var state = stored || memory;
      return state && state.until > 0 && state.span > 0 ? state : null;
    }
    function save(state) {
      memory = state;
      try {
        if (state) localStorage.setItem(KEY, JSON.stringify(state)); else localStorage.removeItem(KEY);
      } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    // Brings every band up to date; returns the milliseconds left, 0 when nothing is counting down.
    function render() {
      var bands = document.querySelectorAll('[data-reserve]');
      if (!bands.length) return 0;
      // The cart drawer swaps its panel, band included, after every cart change, so its band knows the cart best
      var lead = document.querySelector('#CartDrawer [data-reserve]') || bands[0];
      var units = parseInt(lead.getAttribute('data-units'), 10) || 0;
      var state = load();
      if (!units) {
        if (state) save(null);
        bands.forEach(function (band) { band.hidden = true; });
        return 0;
      }
      var now = Date.now();
      if (!state || units > state.units) {
        var span = (parseInt(lead.getAttribute('data-minutes'), 10) || 10) * 60000;
        state = { until: now + span, span: span, units: units };
        save(state);
      } else if (units < state.units) {
        state.units = units;
        save(state);
      }
      var left = Math.max(0, state.until - now);
      var seconds = Math.ceil(left / 1000);
      var clock = pad(Math.floor(seconds / 60)) + ':' + pad(seconds % 60);
      bands.forEach(function (band) {
        var time = band.querySelector('[data-reserve-time]');
        if (!time) return; // rendered for a cart without reserved lines
        var fill = band.querySelector('[data-reserve-fill]');
        band.hidden = false;
        band.classList.toggle('is-expired', left === 0);
        band.classList.toggle('is-ending', left > 0 && left <= 60000);
        time.textContent = clock;
        if (fill) fill.style.width = Math.min(100, (left / state.span) * 100) + '%';
        // First paint of a fresh band: place the bar without animating it from full width
        if (!band.classList.contains('is-live')) { void band.offsetWidth; band.classList.add('is-live'); }
      });
      return left;
    }

    function run() {
      clearTimeout(timer);
      var left = render();
      if (left > 0) timer = setTimeout(run, left % 1000 || 1000);
    }

    run();
    document.addEventListener('flosh:cart:updated', run);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 990px)');
        // The server renders the slides in the order of the current variant; allSlides keeps the admin order.
        const rendered = Array.from(this.track.children).filter((slide) => slide.dataset.mediaId);
        this.slides = rendered.filter((slide) => !slide.hidden);
        this.allSlides = rendered.sort((a, b) => a.dataset.position - b.dataset.position);
        this.placeholder = this.track.querySelector('[data-placeholder]');
        this.lightbox = this.querySelector('[data-gallery-lightbox]');

        this.setupProgress();

        this.addEventListener('click', (event) => {
          const play = event.target.closest('[data-video-play]');
          if (play) this.playVideo(play);
        });

        if (this.lightbox) {
          this.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-zoom-media]');
            if (trigger) this.openLightbox(trigger.dataset.zoomMedia);
          });
          this.setupLightbox();
        }

        this.bindVariantChange();

        if (this.dataset.initialMedia) this.goToMedia(this.dataset.initialMedia, 'instant');

        // Lead video: starts after the page has loaded, so the poster (the LCP image) goes first.
        const autoplay = this.querySelector('[data-video-autoplay]');
        if (autoplay && !this.reduceMotion.matches) {
          const start = () => this.autoplayVideo(autoplay);
          if (document.readyState === 'complete') start();
          else window.addEventListener('load', start, { once: true });
        }
      }

      // Muted, looping, inline; plays while at least half in view. The sound button (or a tap on the
      // video) switches the sound on and off. If the browser refuses to play, its own controls take over.
      autoplayVideo(slide) {
        const template = slide.querySelector('[data-video-template]');
        const source = template && template.content.querySelector('video');
        const play = slide.querySelector('[data-video-play]');
        if (!source || !play) return;

        const video = source.cloneNode(true);
        video.removeAttribute('poster');
        video.querySelectorAll('img').forEach((image) => image.remove());
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.preload = 'auto';
        play.replaceWith(video);

        const sound = slide.querySelector('[data-video-sound]');
        const toggleSound = () => {
          video.muted = !video.muted;
          if (sound) sound.setAttribute('aria-pressed', String(!video.muted));
          if (!video.muted) video.play().catch(() => {});
        };
        if (sound) {
          sound.hidden = false;
          sound.addEventListener('click', toggleSound);
        }
        video.addEventListener('click', toggleSound);

        const tryPlay = () => {
          const started = video.play();
          if (started) {
            started.catch(() => {
              video.controls = true;
              if (sound) sound.hidden = true;
            });
          }
        };

        if (!('IntersectionObserver' in window)) {
          tryPlay();
          return;
        }
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio >= 0.5) tryPlay();
              else video.pause();
            });
          },
          { threshold: [0, 0.5] }
        ).observe(slide);
      }

      behavior(explicit) {
        if (explicit) return explicit;
        return this.reduceMotion.matches ? 'instant' : 'smooth';
      }

      setupProgress() {
        const bar = this.querySelector('[data-gallery-progress-bar]');
        if (!bar) return;
        if (CSS.supports('(animation-timeline: --x) and (timeline-scope: --x)')) return;

        const track = this.track;
        let queued = false;

        const paint = () => {
          queued = false;
          const steps = Math.max(this.slides.length - 1, 1);
          const range = track.scrollWidth - track.clientWidth;
          const progress = range > 0 ? Math.min(Math.max(track.scrollLeft / range, 0), 1) : 0;
          bar.style.transform = 'translateX(' + progress * steps * 100 + '%)';
        };

        track.addEventListener(
          'scroll',
          () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(paint);
          },
          { passive: true }
        );
        window.addEventListener('resize', paint, { passive: true });
        this.paintProgress = paint;
        paint();
      }

      // Show only the media the selected variant claims (data-variants); generic media always stays,
      // at the place it has in the admin's media list (data-position). Same rule as the Liquid above.
      applyVariant(variantId) {
        const id = String(variantId);
        const own = [];
        const generic = [];
        this.allSlides.forEach((slide) => {
          const owners = (slide.dataset.variants || '').split(/\s+/).filter(Boolean);
          slide.hidden = owners.length > 0 && !owners.includes(id);
          if (!owners.length) generic.push(slide);
          else if (!slide.hidden) own.push(slide);
        });

        this.slides = [];
        while (own.length || generic.length) {
          const genericNext = generic.length && (Number(generic[0].dataset.position) <= this.slides.length || !own.length);
          this.slides.push(genericNext ? generic.shift() : own.shift());
        }

        // Put the slides in that order. Generic slides stay where they are (a playing video is not
        // touched); the variant's own slides move in front of the next generic one, or to the end.
        this.slides.forEach((slide, index) => {
          if (!slide.dataset.variants) return;
          const anchor = this.slides.slice(index + 1).find((next) => !next.dataset.variants);
          this.track.insertBefore(slide, anchor || this.placeholder || null);
        });

        this.allSlides.forEach((slide) => slide.classList.remove('product-gallery__slide--lead'));
        if (this.slides[0]) this.slides[0].classList.add('product-gallery__slide--lead');
        if (this.placeholder) this.placeholder.hidden = this.slides.length > 0;
        this.style.setProperty('--slide-count', Math.max(this.slides.length, 1));
        this.dataset.currentVariant = id;

        if (this.zoom) {
          this.zoom.controller.abort();
          this.zoom = null;
          this.lightbox.querySelector('[data-lightbox-track]').replaceChildren();
        }
        if (this.paintProgress) this.paintProgress();
        this.track.scrollTo({ left: 0, behavior: 'instant' });
      }

      goToMedia(mediaId, explicit) {
        const slide = this.slides.find((item) => item.dataset.mediaId === String(mediaId));
        if (!slide) return;

        const behavior = this.behavior(explicit);
        if (this.desktop.matches) {
          slide.scrollIntoView({ behavior, block: 'center', inline: 'nearest' });
        } else {
          slide.scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
        }
      }

      bindVariantChange() {
        const pairs = (this.dataset.variantMedia || '').split(/\s+/).filter(Boolean);

        const map = {};
        pairs.forEach((pair) => {
          const [variantId, mediaId] = pair.split(':');
          map[variantId] = mediaId;
        });

        const scope = this.closest('.shopify-section') || document;
        scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
          input.addEventListener('change', (event) => {
            this.applyVariant(event.target.value);
            const mediaId = map[event.target.value];
            if (mediaId) this.goToMedia(mediaId, 'instant');
          });
        });
      }

      createCarousel(track, { prev, next, counter, current }) {
        const slides = Array.from(track.children);
        const controller = new AbortController();
        const { signal } = controller;
        const carousel = { track, slides, index: 0, controller };
        const multiple = slides.length > 1;

        [prev, next, counter].forEach((element) => {
          if (element) element.hidden = !multiple;
        });

        const setIndex = (index) => {
          if (index === carousel.index || !slides[index]) return;
          carousel.index = index;
          if (current) current.textContent = index + 1;
        };

        carousel.goTo = (index, explicit) => {
          if (!slides.length) return;
          const target = ((index % slides.length) + slides.length) % slides.length;
          track.scrollTo({ left: slides[target].offsetLeft, behavior: this.behavior(explicit) });
          setIndex(target);
        };

        if (prev) prev.addEventListener('click', () => carousel.goTo(carousel.index - 1), { signal });
        if (next) next.addEventListener('click', () => carousel.goTo(carousel.index + 1), { signal });

        track.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              carousel.goTo(carousel.index + 1);
            } else if (event.key === 'ArrowLeft') {
              event.preventDefault();
              carousel.goTo(carousel.index - 1);
            }
          },
          { signal }
        );

        let settle;
        track.addEventListener(
          'scroll',
          () => {
            clearTimeout(settle);
            settle = setTimeout(() => {
              setIndex(Math.round(Math.abs(track.scrollLeft) / track.clientWidth));
            }, 120);
          },
          { passive: true, signal }
        );

        return carousel;
      }

      buildLightbox() {
        const track = this.lightbox.querySelector('[data-lightbox-track]');

        this.slides.forEach((slide) => {
          // Photos only: a video plays in its own tile and has the browser's full-screen button.
          const source = slide.querySelector('[data-zoom-media] img');
          if (!source || !slide.dataset.mediaId) return;

          const item = document.createElement('div');
          item.className = 'product-gallery__lightbox-slide';
          item.dataset.mediaId = slide.dataset.mediaId;
          item.setAttribute('role', 'group');
          item.setAttribute('aria-roledescription', 'slide');

          const image = document.createElement('img');
          image.className = 'product-gallery__lightbox-image';
          image.src = source.src.replace(/([?&])width=\d+/, '$1width=2048');
          image.alt = source.alt;
          image.loading = 'lazy';
          image.decoding = 'async';

          item.append(image);
          track.append(item);
        });

        const total = this.lightbox.querySelector('[data-lightbox-total]');
        if (total) total.textContent = track.children.length;

        this.zoom = this.createCarousel(track, {
          prev: this.lightbox.querySelector('[data-lightbox-prev]'),
          next: this.lightbox.querySelector('[data-lightbox-next]'),
          counter: this.lightbox.querySelector('[data-lightbox-counter]'),
          current: this.lightbox.querySelector('[data-lightbox-current]'),
        });

      }

      setupLightbox() {
        this.lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => this.lightbox.close());

        this.lightbox.addEventListener('click', (event) => {
          if (event.target === this.lightbox || event.target.classList.contains('product-gallery__lightbox-slide')) {
            this.lightbox.close();
          }
        });

        this.lightbox.addEventListener('close', () => {
          if (this.desktop.matches || !this.zoom) return;
          const slide = this.zoom.slides[this.zoom.index];
          if (slide) this.goToMedia(slide.dataset.mediaId, 'instant');
        });
      }

      openLightbox(mediaId) {
        if (!this.zoom) this.buildLightbox();
        this.lightbox.showModal();
        const index = this.zoom.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        this.zoom.goTo(Math.max(index, 0), 'instant');
      }

      // Swap the play button for the player kept in the slide's template; the poster image stays
      // underneath, so Shopify's thumbnail-sized poster and fallback image are dropped.
      playVideo(button) {
        const slide = button.closest('.product-gallery__slide');
        const template = slide && slide.querySelector('[data-video-template]');
        const source = template && template.content.querySelector('video');
        if (!source) return;

        const video = source.cloneNode(true);
        video.removeAttribute('poster');
        video.querySelectorAll('img').forEach((image) => image.remove());
        button.replaceWith(video);
        video.focus({ preventScroll: true });

        // On phones a tap on the peeking slide brings it into view first.
        if (!this.desktop.matches) {
          slide.scrollIntoView({ behavior: this.behavior(), block: 'nearest', inline: 'start' });
        }

        const started = video.play();
        if (started) started.catch(() => {});
        this.pauseOutOfView(video);
      }

      // Pause a playing video once it has been in view and is swiped or scrolled away.
      pauseOutOfView(video) {
        if (!('IntersectionObserver' in window)) return;

        if (!this.videoObserver) {
          this.videosInView = new WeakSet();
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const player = entry.target;
                if (entry.intersectionRatio >= 0.5) {
                  this.videosInView.add(player);
                  return;
                }
                if (!this.videosInView.has(player)) return;
                this.videosInView.delete(player);

                const detached =
                  document.fullscreenElement === player ||
                  document.pictureInPictureElement === player ||
                  player.webkitDisplayingFullscreen;
                if (!detached) player.pause();
              });
            },
            { threshold: 0.5 }
          );
        }

        this.videoObserver.observe(video);
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-picker')) {
    class VariantPicker extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.input = this.form ? this.form.querySelector('input[name="id"]') : null;
        const map = this.querySelector('[data-variant-map]');
        this.variants = map ? JSON.parse(map.textContent) : [];
        this.addEventListener('change', () => this.sync());
      }

      sync() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        const selected = fieldsets.map((fieldset) => {
          const checked = fieldset.querySelector('input:checked');
          const label = fieldset.querySelector('[data-selected-value]');
          if (label) label.textContent = checked ? checked.value : '';
          return checked ? checked.value : null;
        });

        const variant = this.variants.find((candidate) =>
          candidate.options.every((value, index) => value === selected[index])
        );
        if (!variant || !this.input) return;

        this.input.value = variant.id;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-deal"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-quantity-deal]').forEach(function (deal) {
      var form = deal.closest('form');
      var qty = form && form.querySelector('[name="quantity"]');
      if (!qty) return;
      var tiles = Array.prototype.slice.call(deal.querySelectorAll('[data-deal-qty]'));
      var pieces = function (tile) { return parseInt(tile.getAttribute('data-deal-qty'), 10); };

      // The pressed tile is the highest tier the quantity reaches
      function sync() {
        var n = parseInt(qty.value, 10) || 1;
        var reached = null;
        tiles.forEach(function (tile) {
          if (n >= pieces(tile) && (!reached || pieces(tile) > pieces(reached))) reached = tile;
        });
        tiles.forEach(function (tile) { tile.setAttribute('aria-pressed', String(tile === reached)); });
      }

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          // A second click on the tile that set the quantity goes back to one piece
          qty.value = (parseInt(qty.value, 10) || 1) === pieces(tile) ? 1 : pieces(tile);
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      qty.addEventListener('change', sync);
      qty.addEventListener('input', sync);

      var prices = {};
      var json = deal.querySelector('[data-deal-prices]');
      try { prices = JSON.parse(json ? json.textContent : '{}'); } catch (e) {}
      var idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.addEventListener('change', function () {
          var list = prices[idInput.value];
          if (!list) return;
          tiles.forEach(function (tile, i) {
            var price = tile.querySelector('[data-deal-price]');
            if (price && list[i]) price.textContent = list[i];
          });
        });
      }

      sync();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.querySelector('[data-shipping-bar]')) return;
    function money(cents, currency) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    }
    function render(total) {
      // Query afresh: the cart drawer replaces its whole panel, bar included, on every update.
      document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
        var currency = bar.getAttribute('data-currency');
        var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
        var remaining = Math.max(0, threshold - total);
        var percent = Math.min(100, Math.round((total / threshold) * 100));
        var text = bar.querySelector('[data-shipping-text]');
        var fill = bar.querySelector('[data-shipping-fill]');
        if (text) {
          text.innerHTML = remaining > 0
            ? 'Nog <b>' + money(remaining, currency) + '</b> tot gratis verzending'
            : '<b>Gratis verzending</b>, je zit boven ' + money(threshold, currency);
        }
        if (fill) { fill.style.width = percent + '%'; fill.classList.toggle('is-complete', remaining === 0); }
        var track = bar.querySelector('[role="progressbar"]');
        if (track) track.setAttribute('aria-valuenow', percent);
      });
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price); })
        .catch(function () {});
    }
    // The drawer dispatches flosh:cart:updated after every add and change (its own bar arrives
    // server-rendered in that swap); one refresh keeps any bar outside the drawer in step.
    document.addEventListener('flosh:cart:updated', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
